 if (window.location.pathname.includes('cmc-matte-foundation-copy')) {
      window.location.replace('/products/cmc-matte-foundation');
}
if (window.location.pathname.includes('cmc-concealer-copy')) {
    window.location.replace('/products/cmc-concealer');
}
if (window.location.pathname.includes('cmc-insane-shifters-eye-shadow-bundle')) {
    window.location.replace('/products/cmc-insane-shifters-eye-shadow');
}
if (window.location.pathname.includes('cmc-duo-drama-eyeliners-essentials-bundle')) {
    window.location.replace('/products/cmc-duo-drama-eyeliners-essentials');
}
if (window.location.pathname.includes('cmc-sketch-eyeliner-bundle')) {
    window.location.replace('/products/cmc-sketch-eyeliner');
}

if (window.location.pathname.includes('cmc-star-dust-highlighters-bundle')) {
    window.location.replace('/products/cmc-star-dust-highlighters');
}
if (window.location.pathname.includes('cmc-power-lash-mascara-bundle-2')) {
    window.location.replace('/products/cmc-power-lash-mascara');
}
if (window.location.pathname.includes('cmc-diamond-rush-lipstick-bundle-2')) {
    window.location.replace('/products/cmc-diamond-rush-lipstick');
}
if (window.location.pathname.includes('cmc-stunning-longstay-liquid-lip-bundle-2')) {
    window.location.replace('/products/cmc-stunning-longstay-liquid-lip');
}

if (window.location.pathname.includes('cmc-hd-cover-compact-powder-bundle-2')) {
    window.location.replace('/products/cmc-hd-cover-compact-powder');
}
if (window.location.pathname.includes('cmc-concealer-bundle-2')) {
    window.location.replace('/products/cmc-concealer');
}
if (window.location.pathname.includes('cmc-matte-foundation-bundle-2')) {
    window.location.replace('/products/cmc-matte-foundation');
}
if (window.location.pathname.includes('cmc-diamond-rush-lipstick-copy')) {
    window.location.replace('/products/cmc-diamond-rush-lipstick');
}
if (window.location.pathname.includes('cmc-stellar-eyeliner-holographic-glitter-graphic-look-copy')) {
    window.location.replace('/products/cmc-stellar-eyeliner');
}
if (window.location.pathname.includes('cmc-hd-cover-compact-powder-copy')) {
    window.location.replace('/products/cmc-hd-cover-compact-powder');
}

if (window.location.pathname.includes('cmc-power-lash-mascara-copy')) {
    window.location.replace('/products/cmc-power-lash-mascara');
}
if (window.location.pathname.includes('cmc-true-false-mascara-copy')) {
    window.location.replace('/products/cmc-true-and-false-mascara');
}
if (window.location.pathname.includes('cmc-sketch-eyeliner-copy')) {
    window.location.replace('/products/cmc-sketch-eyeliner');
}
if (window.location.pathname.includes('cmc-pro-pore-conceal-primer-copy')) {
    window.location.replace('/products/cmc-pro-pore-conceal-primer');
}
if (window.location.pathname.includes('cmc-set-fix-loose-powder-copy')) {
    window.location.replace('/products/cmc-set-fix-loose-powder');
}

if (window.location.pathname.includes('cmc-flattering-nude-lipstick-copy')) {
    window.location.replace('/products/cmc-flattering-nude-lipstick');
}
if (window.location.pathname.includes('cmc-stunning-longstay-liquid-lip-copy')) {
    window.location.replace('/products/cmc-stunning-longstay-liquid-lip');
}
